<template>
  <div class="course">
    <h1>{{ currentCourse.title }}</h1>
    <div class="row" v-if="activeVideoPosition !== null">
      <div class="column">
        <VimeoPlayer ref="vimeoPlayer" :videoUrl="currentVideo.file"/>
        <VideoDescription
            v-if="currentVideo.additional"
            :additionals="currentVideo.additional"
            @selectTime="onSelectTime"
            @likeVideoPart="onLikeVideoPart"
        />
      </div>
      <CourseList
          @selectVideo="onSelectVideo"
          @like="onLike"
          :list="currentCourse.downloads"/>
    </div>
  </div>
</template>

<script>

import VimeoPlayer from "@/components/market/VimeoPlayer";
import CourseList from "@/components/market/course/CourseList";
import VideoDescription from "@/components/market/course/VideoDescription";

export default {
  name: "Course",
  data() {
    return {
      activeVideoPosition: null,
    }
  },
  components: {
    VimeoPlayer,
    CourseList,
    VideoDescription
  },
  methods: {
    async onSelectVideo(id) {
      if (this.activeVideoPosition !== null) {
        this.currentCourse.downloads[this.activeVideoPosition].status = 'watched';
      }
      this.activeVideoPosition = id;
      this.currentCourse.downloads[id].status = 'watching'
    },
    onLike(id) {
      this.currentCourse.downloads[id].liked = ! this.currentCourse.downloads[id].liked;
    },
    onSelectTime(data) {
      this.$refs.vimeoPlayer.onChangeTime(data);
    },
    onLikeVideoPart(partId) {
      const liked = this.currentVideo.additional.timecodes[partId].timecode_with_title.liked;
      this.currentVideo.additional.timecodes[partId].timecode_with_title.liked = !liked;
    }
  },
  computed: {
    currentCourse () {
      return this.$store.getters['market/getProductById'](this.$route.params.id);
    },
    currentVideo() {
      return this.currentCourse.downloads[this.activeVideoPosition];
    }
  },
  created() {
    this.onSelectVideo(0);
  },
  mounted() {
    this.currentCourse.downloads = this.currentCourse.downloads.map( (video, index) => {
      if (video.status === 'watching' && index !== 0) {
        video.status = 'watched';
      }
      return video;
    });
  }
}
</script>

<style lang="scss" scoped>
.course {
  padding-left: 20px;
  .row {
    display: flex;
    &>.column {
      width: 70%;
    }
    .courseList {
      width: 30%;
    }
  }
}
</style>